import React, { Component} from 'react';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import { Row, Col } from 'reactstrap';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import axios from 'axios';
import * as constants from '../config/constants';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
let QRCode = require('qrcode.react');

const styles = {
	appBar: {
		position: 'relative',
	},
	flex: {
		flex: 1,
	},
	card : {
		width : 'auto',
		hieght : '100%',
	},
	formControl: {	
		minWidth: '100%',
		margin : '0 0 15px 0'
	},

};

function Transition(props) {
	return <Slide direction="up" {...props} />;
}
class CreateAsset extends Component {
	constructor(props){
		super(props);
		this.state = {
			open : this.props.open,
			categoryId : '',
			vendorId : '',
			currentAsset : (this.props.currentAsset) ? this.props.currentAsset : null,
			closeCB : (this.props.closeCB) ? this.props.closeCB : null,
			createCB : this.props.createCB ? this.props.createCB : null,
			description : '',
			admin : '',
			company : '',
			category : [],
			vendor : [],
			qrCodeGenerated: false
		}
		this.handleClose = this.handleClose.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.createAsset = this.createAsset.bind(this);
		this.handleEditAsset = this.handleEditAsset.bind(this);
	}
	handleEditAsset(){
		let that = this;
		let copiedStates = Object.assign({},this.state);
		let request={
			name: copiedStates.name,
			categoryId: copiedStates.categoryId,
			vendorId: copiedStates.vendorId,
			price: copiedStates.price,
			description: copiedStates.description,
			company: copiedStates.company,
			admin: copiedStates.admin,
		}
		axios.put(constants.API_BASE_URL + "asset/" + this.state.id,request)
		.then(function (response) {
			that.state.createCB && that.state.createCB(response.data.details);
		})
		.catch(function (error) {
		});
		this.setState({open : false});
	}
	componentWillReceiveProps(nextProps) {
		let copiedStates = Object.assign({},this.state);
		copiedStates.open = nextProps.open;
		if(nextProps.currentAsset){
			copiedStates.name = nextProps.currentAsset.name;
			copiedStates.id = nextProps.currentAsset.id;
			copiedStates.description = nextProps.currentAsset.description;
			copiedStates.price = nextProps.currentAsset.price;
			copiedStates.categoryId = nextProps.currentAsset.categoryId;
			copiedStates.company = nextProps.currentAsset.company;
			copiedStates.admin = nextProps.currentAsset.admin;
			copiedStates.vendorId = nextProps.currentAsset.vendorId;
		} else {
			copiedStates.name = '';
			copiedStates.id = '';
			copiedStates.description = '';
			copiedStates.price = '';
			copiedStates.categoryId = '';
			copiedStates.company = '';
			copiedStates.admin = '';
			copiedStates.vendorId = '';
		}
		copiedStates.currentAsset = nextProps.currentAsset;
		this.setState(copiedStates);
	}
	componentDidMount(){
		let copiedStates = Object.assign({},this.state);
		var that = this;
		axios.get(constants.API_BASE_URL + "category")
		.then(function(response){
			var category = [];
			copiedStates.category = response.data.details;
			axios.get(constants.API_BASE_URL + "vendor")
			.then(function(response){
				var vendor = [];
				copiedStates.vendor = response.data.details;
				that.setState(copiedStates);
			})
			.catch(function(error){
				alert(error);
			})
		})
		.catch(function(error){
			alert(error);
		});
		// get vendor list
	}
	handleClose() {
		let copiedStates = Object.assign({}, this.state);
		copiedStates.open = false;
		copiedStates.closeCB && copiedStates.closeCB();
		this.setState(copiedStates);
	}
	createAsset() {
		let that = this;
		let copiedStates = Object.assign({}, this.state);
		let request = {
			name: copiedStates.name,
			categoryId: copiedStates.categoryId,
			vendorId: copiedStates.vendorId,
			price: copiedStates.price,
			description: copiedStates.description,
			company: copiedStates.company,
			admin: copiedStates.admin,
			duplicateCount: copiedStates.duplicateCount,
		}
		axios.post( constants.API_BASE_URL + "asset",request)
		.then(function (response) {
			that.state.createCB && that.state.createCB(response.data.details);
		})
		.catch(function (error) {
		});
		this.setState({open : false});
	}
	handleInputChange(event) {
		let copiedStates = Object.assign({},this.state);
		copiedStates[event.target.name] = event.target.value;
		this.setState(copiedStates);
	}
	render() {
		const { classes } = this.props;
		var categoryArr = this.state.category;

		var categoryComponent = [];
		for(var i=0;i<categoryArr.length;i++){
			categoryComponent.push(
				<MenuItem value={categoryArr[i].id}>{categoryArr[i].name + " - " + categoryArr[i].type}</MenuItem>
				);
		}
		let vendorArr = this.state.vendor;
		let vendorComponent = [];
		let that = this;
		vendorArr.map((v, i) => {
			vendorComponent.push(
				<MenuItem value={vendorArr[i].id} selected={vendorArr[i].id === that.state.vendorId} >{vendorArr[i].name}</MenuItem>
				);
		});

		return(
			<Dialog
			fullWidth
			open={this.state.open}
			onClose={this.handleClose}
			TransitionComponent={Transition}
			>
			<DialogTitle>{this.state.currentAsset ? "Edit asset" : "Add asset"}</DialogTitle>			
			<DialogContent>
			<TextField
			fullWidth
			id="name"
			name="name"
			placeholder="Name of asset"
			value={this.state.name}
			onChange={this.handleInputChange}
			className={classes.textField}
			InputLabelProps={{
				shrink: true,
			}}
			margin="normal"
			/>
			<FormControl className = {classes.formControl}>
			<InputLabel htmlFor="age-simple">Category</InputLabel>
			<Select
			fullWidth
			value={this.state.categoryId}
			onChange={this.handleInputChange}
			inputProps={{
				name: 'categoryId',
				id: 'categoryId'
			}}
			>
			{categoryComponent}	
			</Select>
			</FormControl>
			<TextField
			fullWidth
			id="price"
			name="price"
			label="Estimated value"
			placeholder="Estimated value of asset"
			value={this.state.price}
			onChange={this.handleInputChange}
			type="number"
			className={classes.textField}
			InputLabelProps={{
				shrink: true,
			}}
			margin="normal"
			/>
			<FormControl className = {classes.formControl}>
			<InputLabel htmlFor="age-simple">Vendor</InputLabel>
			<Select
			fullWidth
			value={this.state.vendorId}
			onChange={this.handleInputChange}
			inputProps={{
				name: 'vendorId',
				id: 'vendorId'
			}}
			>
			{vendorComponent}
			</Select>
			</FormControl>
			<TextField
			fullWidth
			id="description"
			name="description"
			placeholder ="Write description for the asset"
			value={this.state.description}
			onChange={this.handleInputChange}
			className={classes.textField}
			InputLabelProps={{
				shrink: true,
			}}
			margin="normal"
			/>
			<FormControl className = {classes.formControl}>
			<InputLabel>Company</InputLabel>
			<Select
			fullWidth
			value={this.state.company}
			onChange={this.handleInputChange}
			inputProps={{
				name: 'company',
				id: 'company'
			}}
			>
			<MenuItem value={"EC"}>EC</MenuItem>
			<MenuItem value={"ET"}>ET</MenuItem>
			</Select>
			</FormControl>

			<TextField
			fullWidth
			id="admin"
			name="admin"
			label="Admin"
			placeholder="Admin of the asset"
			value={this.state.admin}
			onChange={this.handleInputChange}
			className={classes.textField}
			InputLabelProps={{
				shrink: true,
			}}
			margin="normal"
			/>
			
			{(!this.state.currentAsset) && (
				<TextField
				fullWidth
				defaultValue={1}
				id="duplicateCount"
				name="duplicateCount"
				label="Duplicate Count"
				placeholder="Duplicate Count"
				value={this.state.duplicateCount}
				onChange={this.handleInputChange}
				type="number"
				className={classes.textField}
				InputLabelProps={{
					shrink: true,
				}}
				margin="normal"
				/>
				)}
			
			</DialogContent>
			<DialogActions>
			<Button size="small" color="primary" onClick={this.handleClose}>
			Cancel
			</Button>
			{(this.state.currentAsset) ? (<Button variant="contained" color="primary" onClick = {() => this.handleEditAsset()}>
				Edit
				</Button>) :
			(<Button variant="contained" color="primary" onClick = {() => this.createAsset()}>
				Add
				</Button>)}
			</DialogActions>
			</Dialog>
			)
	}
}


CreateAsset.propTypes = {
	classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CreateAsset);


// WEBPACK FOOTER //
// ./src/asset/createAsset.js